import { Box, Checkbox, FormControlLabel, InputBase } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";

export default function CheckboxEquipment({ label,dinamic,value,...props }) {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  useEffect(()=>{
    if(value>=1) setChecked(true)
  },[])
  return (
    <Box
      mt="20px"
      justifyContent="space-between"
      display="flex"
      alignItems="center"
    >
      <FormControlLabel
        sx={{
          mr: "-10px",
          "& .MuiButtonBase-root": { color: "var(--emr-darkblue) !important" },
          "& .MuiTypography-root": {
            fontSize: "16px",
            fontWeight: "600",
            width:dinamic?"fit-content": "210px"
          },
        }}
        control={<Checkbox checked={checked} onChange={handleChange} />}
        label={label?label : checked?"": dinamic?"نام را وارد کنید":"" }
      />
      {(!label&&checked&&dinamic)&& 
      <InputBase autoFocus placeholder='نام را وارد کنید' />
      } 
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          height: "48px",
          display: "flex",
          // mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          opacity: checked ? "1" : "0.4",
          // alignItems: "center",
        }}
      >
        <InputBase
        {...props}
          disabled={!checked}
          value={value}
          placeholder="تعداد را وارد کنید."
        />
      </Box>
    </Box>
  );
}
